/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoPilotPromotionLogListRequest model module.
 * @module model/LogControllerDtoPilotPromotionLogListRequest
 * @version 1.0
 */
class LogControllerDtoPilotPromotionLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoPilotPromotionLogListRequest</code>.
     * @alias module:model/LogControllerDtoPilotPromotionLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoPilotPromotionLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoPilotPromotionLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoPilotPromotionLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoPilotPromotionLogListRequest} The populated <code>LogControllerDtoPilotPromotionLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoPilotPromotionLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('materialNftUid')) {
                obj['materialNftUid'] = ApiClient.convertToType(data['materialNftUid'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoPilotPromotionLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoPilotPromotionLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoPilotPromotionLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

LogControllerDtoPilotPromotionLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['accountNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['nftUid'] = undefined;

/**
 * @member {Number} materialNftUid
 */
LogControllerDtoPilotPromotionLogListRequest.prototype['materialNftUid'] = undefined;






export default LogControllerDtoPilotPromotionLogListRequest;

